import React from "react"

interface ObjectRendererProps {
  data: any
  indentLevel?: number
}

export const ObjectRenderer: React.FC<ObjectRendererProps> = ({
  data,
  indentLevel = 0,
}) => {
  if (data === null || data === undefined) {
    return (
      <span style={{ color: "#808080", marginLeft: indentLevel * 10 }}>
        null
      </span>
    )
  }

  if (Array.isArray(data)) {
    if (data.length === 0) {
      return (
        <span style={{ color: "#808080", marginLeft: indentLevel * 10 }}>
          []
        </span>
      )
    }

    return (
      <ul
        style={{
          textAlign: "left",
          paddingLeft: 20,
          margin: 0,
          marginLeft: indentLevel * 10,
        }}
      >
        {data.map((item, index) => (
          <li key={index} style={{ margin: "5px 0" }}>
            <ObjectRenderer data={item} indentLevel={0} />
          </li>
        ))}
      </ul>
    )
  }

  if (typeof data === "object") {
    const keys = Object.keys(data)
    if (keys.length === 0) {
      return (
        <span style={{ color: "#808080", marginLeft: indentLevel * 10 }}>
          {}
        </span>
      )
    }

    return (
      <div style={{ marginLeft: indentLevel * 10, textAlign: "left" }}>
        {keys.map((key) => {
          const value = data[key]
          const isComplex = Array.isArray(value) || typeof value === "object"

          return (
            <div key={key} style={{ margin: "2px 0" }}>
              {isComplex ? (
                <>
                  <span style={{ color: "#881391", fontWeight: "bold" }}>
                    {key}:
                  </span>
                  <ObjectRenderer data={value} indentLevel={indentLevel + 1} />
                </>
              ) : (
                <span>
                  <span style={{ color: "#881391", fontWeight: "bold" }}>
                    {key}:
                  </span>{" "}
                  <span style={{ color: "#1a1aa6" }}>
                    {formatPrimitive(value)}
                  </span>
                </span>
              )}
            </div>
          )
        })}
      </div>
    )
  }

  // Примитивные значения
  return (
    <span style={{ color: "#1a1aa6", marginLeft: indentLevel * 10 }}>
      {formatPrimitive(data)}
    </span>
  )
}

// Вспомогательная функция для форматирования примитивов
function formatPrimitive(value: any): string {
  if (typeof value === "string") {
    return `"${value}"`
  }
  return String(value)
}

// Компонент-обертка с стилями
interface ObjectViewerProps {
  data: any
  title?: string
}

export const ObjectViewer: React.FC<ObjectViewerProps> = ({
  data,
  title = "Object Structure",
}) => {
  return (
    <div
      style={{
        fontFamily: "monospace",
        padding: "20px",
        border: "1px solid #ddd",
        borderRadius: "4px",
        backgroundColor: "#f9f9f9",
      }}
    >
      {title && <h3 style={{ marginTop: 0 }}>{title}</h3>}
      <ObjectRenderer data={data} />
    </div>
  )
}
